import { render } from "./BrandFaqContent.vue?vue&type=template&id=5124b251&scoped=true"
import script from "./BrandFaqContent.vue?vue&type=script&lang=js"
export * from "./BrandFaqContent.vue?vue&type=script&lang=js"

import "./BrandFaqContent.vue?vue&type=style&index=0&id=5124b251&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5124b251"]])

export default __exports__